export default "__VITE_ASSET__DQrW90lJ__"